import whenDomReady from "when-dom-ready";
import renderFromPreloadedJSON from "~/common/renderFromPreloadedJSON";
import FoodServiceResourcesSearch from "./FoodServiceResourcesSearch";

whenDomReady(() => {
  renderFromPreloadedJSON(
    FoodServiceResourcesSearch,
    "FoodServiceResourcesSearch",
  );
});
